import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import PrivacyPolicy from '@/modules/legal/PrivacyPolicy'
import { Stack } from 'expo-router'
import { ScrollView } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export default function PrivacyPage() {
  const headerLeftItems = useWebBackButton('/forms')
  const insets = useSafeAreaInsets()

  return (
    <>
      <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />
      <ScrollView
        contentInsetAdjustmentBehavior="automatic"
        contentContainerStyle={{ paddingBottom: insets.bottom }}
      >
        <PrivacyPolicy />
      </ScrollView>
    </>
  )
}
